const AnalyticsDashboard = () => import('@/components/analytics/Dashboard.vue')
const AnalyticsSells = () => import('@/components/analytics/Sells.vue')
const AnalyticsCosts = () => import('@/components/analytics/Costs.vue')
const AnalyticsAnualReport = () => import('@/components/analytics/AnualReport.vue')
const AnalyticsRetentions = () => import('@/components/analytics/Retentions.vue')
const AnalyticsConfronta = () => import('@/components/analytics/Confronta.vue')

const permissionsAnalytics = [
  'dashboard_analitica',
  'ventas',
  'costos_gastos',
  'informe_anual',
  'retenciones',
  'confronta_analitica'
]

export const analyticsRoutes = [
  {
    path: '/analytics',
    meta: { breadcrumb: 'Analítica', requiresAuth: true, permissions: permissionsAnalytics},
    children: [
      {
        path: 'dashboard',
        component: AnalyticsDashboard,
        meta: { breadcrumb: 'Dashboard', permissions: [permissionsAnalytics[0]] },
      },
      {
        path: 'sells',
        component: AnalyticsSells,
        meta: { breadcrumb: 'Ventas', permissions: [permissionsAnalytics[1]] },
      },
      {
        path: 'costs',
        component: AnalyticsCosts,
        meta: { breadcrumb: 'Costos/Gastos', permissions: [permissionsAnalytics[2]] },
      },
      {
        path: 'anual-report',
        component: AnalyticsAnualReport,
        meta: { breadcrumb: 'Informe Anual', permissions: [permissionsAnalytics[3]] },
      },
      {
        path: 'retentions',
        component: AnalyticsRetentions,
        meta: { breadcrumb: 'Retenciones', permissions: [permissionsAnalytics[4]] },
      },
      {
        path: 'confronta',
        component: AnalyticsConfronta,
        meta: { breadcrumb: 'Confronta', permissions: [permissionsAnalytics[5]] },
      },
    ],
  }
]
